import { useCallback, useState } from "react";
import clsx from "clsx";

import PageShell from "../../components/shared/page-shell/page-shell.tsx";
import { InsuranceFiltersCard } from "../../components/features/insurance-tracking/components/insurance-filters.tsx";
import { InsuranceStatsCards } from "../../components/features/insurance-tracking/components/insurance-stats.tsx";
import { InsuranceTable } from "../../components/features/insurance-tracking/components/insurance-table.tsx";
import {
  useInsuranceRecords,
  useInsuranceStats,
} from "../../components/features/insurance-tracking/hooks/use-insurance-tracking.ts";
import type { InsuranceFilters } from "../../components/features/insurance-tracking/types.ts";

const EMPTY_FILTERS: InsuranceFilters = { employeeId: "", status: "" };

export default function InsuranceTrackingPage({
  title = "Insurance Tracking",
  description = "View employee insurance enrollment and policy status.",
}: {
  title?: string;
  description?: string;
}) {
  const [filters, setFilters] = useState<InsuranceFilters>(EMPTY_FILTERS);
  const stats = useInsuranceStats();
  const records = useInsuranceRecords(filters);

  const applyFilters = useCallback((next: InsuranceFilters) => {
    setFilters(next);
  }, []);

  const resetFilters = useCallback(() => {
    setFilters(EMPTY_FILTERS);
  }, []);

  return (
    <PageShell>
     

      <InsuranceStatsCards stats={stats.stats} loading={stats.loading} />
      <InsuranceFiltersCard
        value={filters}
        loading={records.loading}
        onApply={applyFilters}
        onReset={resetFilters}
      />
      <InsuranceTable records={records.records} loading={records.loading} />
    </PageShell>
  );
}
